import { render, staticRenderFns } from "./SendNotice.vue?vue&type=template&id=cc5199b8&"
import script from "./SendNotice.vue?vue&type=script&lang=js&"
export * from "./SendNotice.vue?vue&type=script&lang=js&"
import style0 from "./SendNotice.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "SendNotice.vue"
export default component.exports